const BaseURL = "https://partnersapi.applygateway.com/api/";
const BaseURLSocialAPI = "https://socialapi.hireintelligence.io/api/";
const LandingPageAPI = "https://analytics.newcareer.site/api/"
const WebLinks = {
    // user
    Login: BaseURL + 'Login/login',
    GetOTP: BaseURL + 'Login/SendOtp',
    VerifyOTP: BaseURL + 'Login/VerifyOtp',
    ResendPasswordOTP: BaseURL + 'Login/ForgotHIPassword',
    VerifyEmailRedirect: BaseURL + 'HiLiteEmail/HILiteUpdateEmailLog',
    LogPageAccess: BaseURL + 'PageAccessLog/InsertPageAccessLog',

    //buyer
    LoggedInBuyerDetails: BaseURL + 'Buyer',
    SubBuyerList: BaseURL + 'Buyer/BuyerSubList/',
    GetBuyerDetails: BaseURL + 'Buyer/',
    GetIntercomToken: BaseURL + 'Intercom/getjwt?buyerId=',
    SaveProfileDetails: BaseURL + "",
    GEtSubBuyerAllotedList: BaseURL+ "Buyer/GetSubBuyerList?buyerId=",
    
    //click reports
    GetClickReportDetails: BaseURL + 'Clicks',
    GetClickReportDetailedInfo: BaseURL + 'Clicks/ClickReportInfo',
    JobUploadHistory: BaseURL + 'Job/UploadHistory?buyerId=',
    GetYourJobsListing: BaseURL + 'Job?buyerId=',
    GetAllYourJobsListing: BaseURL + 'Job/GetAllJobs?buyerId=',
    GetJobBoardBoostsListing: BaseURL + 'Job/GetBuyJobBoardBoosts?buyerId=',
    GetJobBoardBoostsAdminListing: BaseURL + 'Job/GetAllSubBuyerBuyJobBoardBoosts?buyerId=',
    GetJobBoardBoostsViewListing: BaseURL + 'Job/GetJobsBoostBasket?buyerId=',
    GetJobBoardBoostsViewRecommendListing: BaseURL + 'Job/GenerateBuyerJobsBasketJson',
    GetJobBoardBoostsSubBuyerViewRecommendListing: BaseURL + 'Job/GenerateSubBuyerJobsBasketJson',
    GetJobBoardBoostSupplierList: BaseURL + 'Job/GetBuyerJobBasketAllowedSupplier?buyerId=',
    GetAllYourJobsListingClick: BaseURL + 'Job/GetClickPostJobs?buyerId=',
    GetAllYourJobsListingPerformance: BaseURL + 'Job/GetPerformance?buyerId=',
    GetAllYourJobsListingPerformanceMulti:BaseURL + 'Job/GetMultiPerformance?buyerId=',
    GetAllYourJobsListingPerformanceClick: BaseURL + 'Job/GetClickPostPerformance?buyerId=',
    GetAllYourJobsListingPerformanceClickMulti: BaseURL + '',
    GetSelectedJobDetails: BaseURL + 'Job/',
    DeleteSelectedJobs: BaseURL + 'Job/BulkDeleteJobs',
    InsertScreeningQuestion: BaseURL + 'Job/InsertBuyerScreeningQuestions?buyerId=',
    DeleteJobBoardBasketJob: BaseURL + 'Job/DeleteBuyerJobBasket?buyerId=',
    AddSelectedRecommendedJobs:BaseURL + 'Job/BookBoostOrderProducts?buyerId=',
    UpdatePriorityLevel: BaseURL + 'Job/PriorityLevel?priorityLevel=',
    UpdateSelectedJob: BaseURL + 'Job',
    AddNewJob: BaseURL + 'Job/PostJob',
    UpdateAllSelectedJobs: BaseURL + 'Job/BulkJobEdit',
    GetClickReportMonthDayDetails: BaseURL + 'Clicks/GetMonthlyClickReport?buyerId=',
    GetClickReportDayDetails: BaseURL + 'Clicks/GetDayClickReport?buyerId=',
    MultiGetClickReportMonthDayDetails: BaseURL + 'MultiClickReport/GetMultiMonthlyClickReport?buyerId=',
    MultiGetClickReportDayDetails: BaseURL + 'MultiClickReport/GetMultiDailyClickReport?buyerId=',
    GetClickSpendPerJob: BaseURL + 'Clicks/SpendPerClick?buyerId=',
    DownloadClickSpendPerJobFile: BaseURL + 'Clicks/GenerateSpendPerClickExcel?buyerId=',
    
    //Clicks occupation report
    DownloadClickOccupationReportExcel: BaseURL + "Clicks/GenerateOccupationExcel?buyerId=",
    GetClickOccupationReportList: BaseURL + "Clicks/GetOccupationClickReport?buyerId=",
    GetClickOccupations: BaseURL + "Clicks/GetClicksOccupations?buyerId=",
    
    //application reports
    GetOccupationOptionsList: BaseURL + "",
    GetOccupationReportList: BaseURL + "Report/GetOccupationList?buyerid=",
    GetMonthlyLocationReport: BaseURL + "Report/GetMonthlyLocationReport?buyerId=",
    GetMultiMonthlyLocationReport: BaseURL + "MultiApplicationReport/GetMultiMonthlyLocationReport?buyerId=",
    GetMultiOccupationReportList: BaseURL + "MultiApplicationReport/MultiOcccupationsMonthReport?buyerId=",
    GetApplicationReport: BaseURL + "Report/ApplicationReport",
    GetApplicationSpendPerJobSupplierReport: BaseURL + "MultiApplicationReport/MultiSupplierMonthReport?buyerId=",
    GetApplicationQualityReport: BaseURL + "Report/QualityReport?buyerId=",
    GetApplicationMonthQualityReport: BaseURL + "Report/GetJobsApplicationsReport?buyerid=",
    GetApplicationMultiQualityReport: BaseURL + "MultiApplicationReport/MultiQualityMonthReport?buyerId=",
    GetApplicationInterviewsHiresReport: BaseURL + "Report/GetInterviewHires?buyerId=",
    GetApplicationMutiInterviewsHiresReport: BaseURL + "MultiApplicationReport/GetMultiInterviewHires?buyerId=",
    GetApplicationDailyDteailedReport: BaseURL + "Report/GetAdminXlsContent",
    GetOccupationsReport: BaseURL + "Report/GetBuyerOccupations?buyerid=",
    GetOccupations: BaseURL + "Report/GetOccupations?buyerId=",
    GetApplicationSpendPerJob: BaseURL + "Report/SpendPerJob?buyerId=",
    GetMultiApplicationSpendPerJob: BaseURL + "MultiApplicationReport/GetMultiSpendPerJob?buyerId=",
    DownloadMultiMonthlyLocationReport: BaseURL + "MultiApplicationReport/GenerateMultiMonthlyLocationReportExcel?buyerId=",
    DownloadApplicationSpendPerJob: BaseURL + "Report/GenerateJobSpendExcel?buyerId=",
    DownloadApplicationSpendPerJobBySupplier: BaseURL + "Report/GenerateSpendPerJobSupplierExcel?buyerId=",
    DownloadMultiApplicationSpendPerJob: BaseURL + "MultiApplicationReport/GenerateMultiSpendPerJobExcel?buyerId=",
    GetApplicationLog: BaseURL + "Report/GetApplicationLog?buyerid=",
    GetYourJobApplications:BaseURL + "Job/GetYourJobsApplications?buyerid=",
    DownloadAplicationLog: BaseURL + "Report/GenerateApplicationLogExcel?buyerid=",
    DownloadApplicationMonthReport: BaseURL + "Report/GenerateMonthReportExcel?buyerId=",
    DownloadApplicationSpendPerSupplierReport: BaseURL + "MultiApplicationReport/GenerateMultiSupplierMonthReportExcel?buyerId=",
    DownloadApplicationQualityReport: BaseURL + "Report/GenerateQualityReportExcel?buyerId=",
    DownloadApplicationMonthQualityReport: BaseURL + "Report/GenerateJobsApplicationExcel?buyerid=",
    DownloadMultiApplicationQualityReport: BaseURL + "MultiApplicationReport/GenerateMultiQualityReportExcel?buyerId=",
    DownloadApplicationInterviesHiresReport: BaseURL + "Report/GenerateInterviewHiresExcel?buyerId=",
    DownloadMultiApplicationInterviesHiresReport: BaseURL + "MultiApplicationReport/GenerateMultiInterviewHiresExcel?buyerId=",
    DownloadOccupationReportAll: BaseURL + "Report/GenerateMonthReportExcel?buyerId=",
    DownloadOccupationReportExcel: BaseURL + "Report/GenerateOccupationExcel?buyerId=",
    DownloadMultiOccupationReportExcel: BaseURL + "MultiApplicationReport/GenerateMultiOccupationExcel?buyerId=",
    DownloadOccupationReport: BaseURL + "Report/GenerateOccupationReportExcel?buyerid=",
    DownloadLocationReportExcel: BaseURL + "Report/GenerateMonthlyLocationReportExcel?buyerid=",
    DownloadApplicationDayReport: BaseURL + "Report/GenerateDailyReportExcel?selectedbuyerid=",
    DownloadYourJobApplications: BaseURL + "Job/GenerateYourJobApplicationExcel?buyerid=",
    MultiDownloadApplicationMonthReport: BaseURL + "MultiApplicationReport/GenerateMultiMonthReportExcel?buyerId=",
    MultiDownloadApplicationDayReport: BaseURL + "",
    GetGAPAnalysisBySupplier: BaseURL + "AppScore/GetGAPAnalysis?buyerId=",
    GetGAPAnalysisByOccupation: BaseURL + "AppScore/GetGAPAnalysisByOccupation?buyerId=",
    GetGAPAnalysisApplications: BaseURL + "AppScore/GetGAPAnalysisApplications?buyerId=",
    //Employee Referral
    DownloadEmployeeReferralReport: BaseURL + "EmployeeReferral/GenerateEmployeeReferralExcel?buyerId=",
    GetEmployeeReferralReport: BaseURL + "EmployeeReferral?buyerId=",

    //Max Apps
    GetAllYourJobsMaxAppsListing: BaseURL + 'Job/GetMaxApps?buyerId=',
    DownloadMaxAppReport: BaseURL + 'Job/GenerateMaxAppsExcel?buyerId=',
    UpdateMaxApps: BaseURL + 'Job/UpdateMultiMaxApps?',

    //Boosts
    GetBoostData: BaseURL + "BoostOrder?buyerId=",
    GetBoostDataAdmin: BaseURL + "MultiBoostOrder?buyerId=",
    GetBoostFinanceData: BaseURL + "MultiBoostOrdersFinance?",
    UpdateInvoiceDetails: BaseURL + "MultiBoostOrdersFinance/UpdateInvoice",

    //your jobs
    PutActiveJob: BaseURL + "Job/UpdateActive",
    PutUpdateSinglePriority: BaseURL + "Job/PriorityLevel?",
    InsertJobBoostBasket: BaseURL + "Job/InsertIntoBuyerJobsBasket",
    UpdateJobBoost: BaseURL + "Job/UpdateBuyerBoost",
    InsertJobBoostBasketSection: BaseURL + "Job/ConvertJobDetailsToJson",
    GetCountryList: BaseURL + "BackofficeBuyer/GetCountryList",
    GetRecruiterList: BaseURL + "ManageSupplierAdmin/GetRecruiterIdList",
    GetBuyerCountry: BaseURL + "Job/GetCountryForBuyer?buyerId=",
    DownloadYourJobReport: BaseURL + "Job/GenerateYourJobExcel?buyerId=",
    DownloadYourJobReportClick:  BaseURL + "Job/GenerateClickPostYourJobExcel?buyerId=",
    DownloadYourJobPerformance: BaseURL + "Job/GenerateYourJobPerformanceExcel?buyerId=",
    DownloadYourJobPerformanceMulti: BaseURL + "Job/GenerateMultiPerformanceExcel?buyerId=",
    DownloadYourJobPerformanceClick: BaseURL + "Job/GenerateClickPostYourJobPerformanceExcel?buyerId=",
    DownloadYourJobPerformanceClickMulti: BaseURL + "",
    RefreshJobList: BaseURL + "Parser/ParserAPICall",
    
    //job occupations
    OccupationsList: BaseURL + "Job/OccupationList?buyerId=",
    JobOccupations: BaseURL + "Job/Occupations?buyerId=",
    NewOccupations: BaseURL + "Job/GetNewOccupationList",
    UpdateJobOccupation: BaseURL + "Job/UpdateJobOccupationId?occupationId=",
    
    //JobRules
    GetOccupationsRule: BaseURL + "JobRule/OccupationRule?",
    GetJobRulesSuppliers: BaseURL + "JobRule/GetSupplierList?",
    InsertOccupationBlock: BaseURL + "JobRule/InsertOccupationBlock",
    DeleteOccupationBlock: BaseURL + "JobRule/DeleteOccupationBlock",
    GetDistributionPriorityRules: BaseURL + "JobRule/PriorityRule?",
    InsertPriorityBlock: BaseURL + "JobRule/InsertPriorityBlock",
    DeletePriorityBlock: BaseURL + "JobRule/DeletePriorityBlock",
    
    //PriorityFilter
    GetPriorityFilters: BaseURL + "PriorityFilter/GetAllFilter?buyerId=",
    AddPriorityFilter: BaseURL + "PriorityFilter/AddFilter",
    DeletePriorityFilter: BaseURL + "PriorityFilter/DeleteFilter?filterId=",
    UpdateOrderPriorityFilter: BaseURL + "PriorityFilter/UpdatePriorityOrderFilter",
    UpdatePriorityFilter: BaseURL + "PriorityFilter/UpdateFilter",
    GetBuyerPriorityFilters: BaseURL + "Job/GetPriorityFilter?buyerId=",
    
    //Budget
    GetBudget: BaseURL + "Budget?buyerId=",
    GetMultiBUdget: BaseURL + "MultiBudgetsAdmin/GetMultiSupplierBudget?buyerId=",
    UpdateBudget: BaseURL + "Budget/UpdateBudget",
    SpendBudget: BaseURL + "Budget/GetBuyerSpend?buyerId=",
    GetMultiBudgetSpend: BaseURL + "MultiBudgetsAdmin/GetMultiSupplierSpend?buyerId=",
    GetMultiBudgetSpendPerCostCenter: BaseURL + "MultiBudgetsAdmin/GetMultiSpendPerCostCenter?buyerId=",
    UpdateAllowedBodgetSupplier: BaseURL +"Budget/UpdateAllowedSupplierBudget",
    BudgetSpendReport: BaseURL + "Budget/GenerateBudgetSpendExcel?buyerId=",
    BudgetSpendMultiReport: BaseURL + "MultiBudgetsAdmin/GenerateMultiBudgetSpendExcel?buyerId=",
    BudgetSpendByCostCenterMultiReport: BaseURL + "MultiBudgetsAdmin/GenerateMultiSpendPerCostCenterExcel?buyerId=",
    GetContractsSpend: BaseURL + "Budget/GetContractSpend?buyerId=",
    GetContractsSpendMulti: BaseURL + "MultiBudgetsAdmin/GetMultiContractSpend?buyerId=",
    UpdateContractSpendValue: BaseURL + "Budget/InsertContractSpendvalue",
    
    //ManageSuppliers
    GetActiveSuppliers: BaseURL + "ManageSupplier/ViewActiveSuppliers",
    GetSelfActiveSuppliers: BaseURL + "AlwaysOn",
    GetMultiActiveSuppliers: BaseURL + "ManageSupplierAdmin/AdminViewActiveSuppliers",
    GetSuppliers: BaseURL + "ManageSupplier/ViewSuppliers",
    GetSelfSuppliers: BaseURL + "AlwaysOn/GetAlwaysOnViewSuppliers",
    GetMultiSuppliers: BaseURL + "ManageSupplierAdmin/AdminViewSuppliers",
    AddSupplier: BaseURL + "ManageSupplier/AddBuyerSupplier",
    AddAlwaysOnSupplier: BaseURL + "AlwaysOn/AddAlwaysOnSuppliers",
    DeleteActiveSuppier:BaseURL + "ManageSupplier/DeleteBuyerSupplier?buyerId=",
    AddMultiSupplier: BaseURL + "ManageSupplierAdmin/AdminAddBuyerSupplier",
    UpdateSupplier: BaseURL + "ManageSupplier/UpdateBuyerSupplier",
    MultiUpdateSupplier: BaseURL + "ManageSupplierAdmin/AdminUpdateBuyerSupplier",
    UpdateKeyPost: BaseURL + "ManageSupplier/UpdateAllowedSupplier",
    MultiUpdateKeyPost: BaseURL + "ManageSupplierAdmin/AdminUpdateAllowedSupplier",
    GetKeyDetails: BaseURL + "ManageSupplier/GetActiveSupplierSinglePostDetails?buyerId=",
    MultiGetKeyDetails: BaseURL +"ManageSupplierAdmin/GetAdminActiveSupplierSinglePostDetails?buyerId=",
    GetSinglePosts: BaseURL + "ManageSupplier/GetSinglePosts?buyerId=",
    DeleteSinglePost: BaseURL + "ManageSupplier/RepostJob?id=",
    GetMultiSupplierAdmin: BaseURL + "MultiSupplierAdmin/GetMultiCostCenters?buyerId=",
    UpdateMultiSupplierAdmin: BaseURL + "MultiSupplierAdmin/UpdateBuyersSuppliers",
    UpdateSupplierAdminBudget: BaseURL + "ManageSupplierAdmin/UpdateBuyerSupplierBudget",
    
    //Job Automates boosts
    DeleteAutomatedBoosts:BaseURL + "AutomateBoost/DeleteBoostAutomate?id=",
    GetAutomatedBoosts:BaseURL + "AutomateBoost?buyerId=",
    GetBoostSelectionData: BaseURL + "AutomateBoost/GetAutomateBoostProducts?buyerId=",
    PostAutomateBoostDetails: BaseURL + "AutomateBoost/InsertBoostAutomate",

    //SocialMedia
    SocialMediaLogin: BaseURLSocialAPI + "login",
    GetJobAd: BaseURLSocialAPI + "job-ads?buyerId=",
    GetGoogleCampaign: BaseURL + "GoogleLandingPage?buyerId=",
    GetReports: BaseURLSocialAPI + "job-ads?buyerId=",
    
    //Social MediaPromo Configure
    GetSocialConfigure: BaseURL + "SocialConfigure?",
    GetSocialOccupations: BaseURL + "SocialConfigure/GetBuyerOccuptionList?buyerId=",
    GetSocialJobs:BaseURL + "SocialConfigure/GetBuyerJobList?buyerId=",
    GetSiteUrlLinks:BaseURL + "SocialConfigure/GetBuyerCareersSiteAndLandingPages?buyerId=",
    DeleteSocialConfig: BaseURL + "SocialConfigure/DeleteSocialConfigure?Id=",
    UpdateSocialConfig: BaseURL + "SocialConfigure/UpdateSocialConfigure",
    AddSocialConfig: BaseURL + "SocialConfigure/AddSocialConfigure",
    UpdateSocialMediaConfig: BaseURL + "SocialConfigure/EditConfigureAd",
    AddSocialMediaConfig: BaseURL + "SocialConfigure/InsertConfigureAd",
    GetSocialConfigureJobURL: BaseURL + "SocialConfigure/GetSocialConfigJobUrl?",
    UpdatePublisAdDetails: BaseURL +"SocialConfigure/UpdateSpendPerAd?",
    InsetSelfPostPublisAdDetails: BaseURL + "SocialConfigure/InsertSocialMediaBoostOrders",
    GetSocialMediaConfigureLiveJobs: BaseURL + "SocialConfigure/GetAllLiveJobs?",
    GetSelectableSocialMediaImages: BaseURL + "SocialPosts/Promo/Images",
    GetSelectableSocialMediaVideos: BaseURL + "SocialPosts/Promo/Videos",
    GetSelectableSocialMediaTexts: BaseURL + "SocialPosts/Promo/Texts",
    UpdatePromoImageVideoURL: BaseURL +"SocialConfigure/UpdatePromoImageVideoURL",
    
    //Settings
    GetLandingPageSettings: BaseURL + "Landing?",
    DeleteLandingPageSettings: BaseURL + "Landing/DeleteLandingDetails?id=",
    UpdateLandingPageSettings: BaseURL + "Landing/UpdateLandingDetails",
    AddLandingPageSettings: BaseURL + "Landing/InsertLandingDetails",
    GetBuyerEmailNotificationSettings: BaseURL + "Settings/GetEmailNotifications?buyerId=",
    UpdateBuyerEmailNotificationSettings: BaseURL + "Settings/UpdateEmailNotifications",

    //TikTokConfigure
    GetTikTokConfigure: BaseURL + "TikTokPromo/GetTikTokPost?",
    DeleteTikTokConfig: BaseURL + "TikTokPromo/DeleteTikTokConfigure?Id=",
    UpdateTikTokConfig: BaseURL + "TikTokPromo/UpdateTikTokConfigure",
    AddTikTokConfig: BaseURL + "TikTokPromo/AddTikTokConfigure",
    
    //ChatBotDomainConfigure
    GetChatBotConfigure: BaseURL + "ChatBotDomainConfig?",
    DeleteChatBotConfig: BaseURL + "ChatBotDomainConfig/DeleteChatBotDomainConfig?Id=",
    UpdateChatBotConfig: BaseURL + "ChatBotDomainConfig/UpdateChatBotDomainConfig",
    AddChatBotConfig: BaseURL + "ChatBotDomainConfig/AddChatBotDomainConfig",
    GetChatBotJobList: BaseURL + 'ChatBotDomainConfig/GetChatBotJobs?buyerId=',
    GetChatBotExists: BaseURL + 'ChatBotDomainConfig/BuyerHasJobs?buyerId=',

    //Candidates
    GetCandidates: BaseURL + "Candidate",
    GetCandidateSuppliers: BaseURL + "Candidate/SupplierList",
    GetCandidateCVDetail: BaseURL + "Candidate/CandidateCombination",
    UpdateCandidateStatus: BaseURL + "Candidate/UpdateStatus",
    SubmitBulkHire: BaseURL + "Candidate/BulkHire?buyerId=",
    SubmitBulkInterviewHire: BaseURL + "Candidate/BulkInterview?buyerId=",
    HireCandidate: BaseURL + "Candidate/HireCandidate?applicationId=",
    InterviewCandidate: BaseURL + "Candidate/InterviewCandidate?applicationId=",
    DownloadExcelFile: BaseURL + "Candidate/GenerateCandidateExcel?",
    GetNoteDetails: BaseURL + "Candidate/GetCandidateNote?noteId=",
    UpdateNoteDetails: BaseURL + "Candidate/UpdateCandidateNote",
    AddNoteDetails: BaseURL +"Candidate/AddCandidateNote",
    DeleteNoteDetails: BaseURL +"Candidate/DeleteCandidateNote",
    DownloadCVFile: BaseURL + "Candidate/DownloadCV?",

    //Analysis
    GenerateAnalysisReport: BaseURL + "Analysis/GetAnalysisExcelFilesInsight",
    GenerateAnalysisExcelInsights: BaseURL + "Analysis/GenerateAnalysisExcelInsights",
    GetMasterAnalysisInsights: BaseURL + "MasterAnalysisReport/GenerateAnalysisInsights",
    GenerateMasterExecutiveSummaryExcel: BaseURL + "MasterAnalysisReport/GenerateMasterExecutiveSummaryExcel?buyerId=",
    SaveAnalysisReport: BaseURL + "Analysis/SaveInsightAnalysis",
    DownloadAnalysisExcel: BaseURL + "Analysis/GenerateAnalysisExcel?buyerId=",
    GenerateExecutiveSummaryExcel: BaseURL + "Analysis/GenerateExecutiveSummaryExcel?buyerId=",
    DownloadAnalysisInsightDoc: BaseURL + "Analysis/GenerateInsightAnalysisDocument",
    GetAnalysisReportData: BaseURL + "Analysis/GetAnalysisExcelDetails?buyerId=",
    GetClaudeModelList: BaseURL + "Analysis/GetClaudeModels",
    SendAnalysisReport: BaseURL + "Analysis/InsertBuyerAnalysisReportTypes",
    GetAnalysisReportType: BaseURL + "Analysis/GetAnalysisReportType",
    GetBuyerAnalysisReport: BaseURL + "Analysis/GetBuyerAnalysisReport",
    DeleteBuyerAnalysisReport: BaseURL + "Analysis/DeleteBuyerAnalysisReport?id=",
    GenerateAnalysisInsights: BaseURL + "Analysis/GenerateAnalysisInsights",
    GetAnalysisReportHistory: BaseURL + "Analysis/GetAnalysisReportHistory?buyerId=",
    GetAnalysisReportHistoryDetails: BaseURL + "Analysis/GetAnalysisReportHistoryDetails?Id=",

    //Occupation filter
    GetOccupationfilter: BaseURL + "OccupationFilter/GetOccupationFilter?buyerId=",
    GetOccupationList: BaseURL + "OccupationFilter/OccupationList?buyerId=",
    UpdateOccupationFilter: BaseURL + "OccupationFilter/UpdateOccupationFilter",
    AddOccupationFilter: BaseURL + "OccupationFilter/AddOccupationFilter",
    DeleteOccupationFilter: BaseURL + "OccupationFilter/DeleteOccupationFilter?id=",
    UpdateOccupationOrderPriorityFilter: BaseURL + "OccupationFilter/UpdatePriorityFilterOrder",
    
    //Sub Buers Admin
    SubBuyerBudget: BaseURL + "MultiBudgetsAdmin?loggedInBuyerId=",
    SubMultiBudgetByCostCenter: BaseURL + "MultiBudgetsAdmin/GetMasterBudget?loggedInBuyerId=",
    SubBuyerNotDelivering: BaseURL + "MultiBudgetsAdmin/NotDelivering?buyerId=",
    SubBuyerOverBudget: BaseURL + "MultiBudgetsAdmin/OverBudget?buyerId=",
    GetSubBuyerSuppliers: BaseURL + "MultiBudgetsAdmin/SupplierList",
    GetSubBuyerMonthlyReport: BaseURL + "MultiApplicationReport/MultiApplicationMonthReport?buyerId=",
    GetSubBuyerDailyReport: BaseURL + "MultiApplicationReport/MultiApplicationDayReport?buyerId=",
    GetSubBuyerJobs: BaseURL + "Job/GetAllSubbuyerJobs?buyerId=",
    PutSubBuyerPriority: BaseURL + "Job/SubBuyerPriorityLevel?",
    
    //InFeed
    GetJobsInFeedBlockListing: BaseURL + 'JobsInFeed?buyerId=',
    GetSupplierContractBoost: BaseURL + "JobsInFeed/BoostSupplierContract?buyerId=",
    UpdateJobsInFeedBlock: BaseURL + 'JobsInFeed/UpdateOverride?buyerId=',
    
    //Override
    InsertJobsOverrideInclude:BaseURL + 'JobsInFeed/InsertOverride?buyerId=',
    DeleteJobsOverrideInclude:BaseURL + 'JobsInFeed/DeleteOverride?buyerId=',
    GetJobsInFeedOverrideListing:BaseURL + 'JobsInFeed/GetJobOverride?buyerId=',
    
    //PriorityRules
    GetPriorityRules: BaseURL + 'PriorityRule?buyerId=',
    AddPriorityRules: BaseURL + 'PriorityRule/AddPriorityRule',
    UpdatePriorityRules: BaseURL + 'PriorityRule/UpdatePriorityRule',
    DeletePriorityRules: BaseURL + 'PriorityRule/DeletePriorityRule?id=',
    
    //QualityFiltering
    GetQualityFilter: BaseURL + 'QualityFilter/',
    AddQualityFilter: BaseURL + 'QualityFilter/',
    
    //QualityFilters:
    QualityFilter: BaseURL + 'QualityFilter?buyerId=',
    SubmitQualityFilterFeedback: BaseURL + 'QualityFilter/UpdateBuyerQualityFilterFeedback',
    QualityFilterSupplier: BaseURL + 'QualityFilter/',
    UpdateQualityFilter: BaseURL + 'QualityFilter/InsertBuyerQualityFilters?buyerId=',
    UpdateQualityFilterSupplier: BaseURL + 'QualityFilter/UpdateFilterSupplier?buyerId=',
    DeleteQualityFilter: BaseURL + 'QualityFilter/DeleteBuyerQualityFilter?buyerId=',
    QualityFilterType: BaseURL + 'QualityFilter/GetQualityFilterType?buyerId=',
    UpdateQualityFilterType: BaseURL + "QualityFilter/QualityFilterTypeUpdate?buyerId=",
    
    //OccupationMatrix
    GetOccupationMatrix: BaseURL + 'Report/GetOccupationMatrix?buyerId=',

    //Multi OccupationMatrix
    GetMultiOccupationMatrix: BaseURL + 'MultiApplicationReport/GetMultiSupplierOccupationMatrix?buyerId=',

    //Orders
    GetOrders: BaseURL + 'Finance?buyerId=',
    GetOrdersAdmin: BaseURL + 'MultiFinance/GetMultiFinance?buyerId=',
    GetOrderProductList: BaseURL + 'MultiFinance/GetBuyerOrderProductDetails',
    AddOrderDetails: BaseURL + 'MultiFinance/InsertFinanceBuyerOrder',
    AddOrderContractAmountDetails: BaseURL + 'Finance/InsertBuyBoostCredits',
    NoOrderOrderDetails: BaseURL + 'CSRepOrders/DoNotInvoiceThisMonth',
    GetBuyerCSList: BaseURL + 'CSRepOrders/GetCSBuyerList',
    GetBuyerCSBillingList: BaseURL + 'CSRepOrders/GetBillingEnabledBuyerList',
    GetOrdersAdminCS: BaseURL + 'CSRepOrders?buyerId=',    
    GetOrdersAdminCSContracts: BaseURL + 'CSRepOrders/GetContractAdminCS?buyerId=',
    GetContractAdminLiveProducts: BaseURL + 'CSRepOrders/GetContractAdminLiveProducts',
    GetOrderPendingInvoiceData: BaseURL + 'CSRepOrders/GetPendingInvoices?',
    GetBilingFinance: BaseURL + 'BillingFinance/GetBillingFinance?buyerId=',
    UpdateBillingFinanceInvoiceDetails: BaseURL + 'BillingFinance/UpdatedInvoiceId?',
    DeleteBuyerOrder: BaseURL + 'CSRepOrders/DeleteBuyerOrderBilling?Id=',
    DeleteBillingFinanceOrder: BaseURL + 'BillingFinance/DeleteBillingFinance?id=',
    PutBlocKInvoice:BaseURL + 'CSRepOrders/UpdateBuyerOrderInvoice?Id=',
    PutLinkedInURL: BaseURL + 'Job/UpdateLinkedinCompanyURL',
    PostCreditInvoice: BaseURL + 'StripePayment/InsertBuyerInvoiceCompanyDetails',

    //Stripe 
    CreateStripeSession: BaseURL + 'StripePayment/CreateSession',
    VerifySession: BaseURL + 'StripePayment/VerifyPayment?sessionId=',

    //Multi Candidate Admin
    GetMultiCandidatesAdmin: BaseURL + 'Candidate/MultiCandidateAdmin',
    DownloadCandidateAdminExcelFile: BaseURL + 'Candidate/GenerateMultiCandidateAdminExcel?',
    GetMultiCandidatesAdminSupliers: BaseURL + 'Candidate/SubBuyerSupplierList',

    //Allowed Suppliers
    GetAllowedSuppliers: BaseURL + 'Report/GetAllowedSupplierList?buyerId=',
    GetALlAllowedSuppliers: BaseURL + 'ManageSupplier/GetAllAllowedSupplierList',
    GetALlAllowedSuppliersAllowedOrders: BaseURL + 'Finance/GetAllowedSupplierList',

    //TikTok Promo
    GetTiktokPromoRecords: BaseURL + 'TikTokPromo/GetBuyerTikTokPromo?buyerId=',

    //Retool
    GetRetoolDashbordLink: BaseURL + 'ReTool',

    //Cost center
    GetCostCenter: BaseURL + 'CostCenter/GetCostCenters?buyerId=',

    //ActivityLogd
    GetPriorityActivityLogs: BaseURL + 'ActivityLog/GetPriorityActionLog?buyerId=',
    GetDistributionRulesActivityLogs: BaseURL + 'ActivityLog/GetDistributionActiveLog?buyerId=',
    GetBudgetLogs: BaseURL + 'ActivityLog/GetBudgetActiveLog?buyerId=',

    //=========================================DASHBOARD========================================
    //Spend Visuals
    GetSpendVisualsApplications:BaseURL +"AnalyticsDashboard/SpendVisuals/Applications",
    GetSpendVisualsApplicationsBySuppliers:BaseURL +"AnalyticsDashboard/SpendVisuals/ApplicationsBySupplier",
    GetSpendVisualsSpend:BaseURL +"AnalyticsDashboard/SpendVisuals/Applications",
    GetSpendVisualsApplicationsThisMonth:BaseURL +"AnalyticsDashboard/SpendVisuals/ApplicationsThisMonth",
    GetSpendVisualsApplicationsThisMonthBySupplier:BaseURL +"AnalyticsDashboard/SpendVisuals/ApplicationsThisMonthBySupplier",
    GetSpendVisualsSpendThisMonth:BaseURL +"AnalyticsDashboard/SpendVisuals/SpendThisMonth",
    GetSpendVisualsSpendLast24Months:BaseURL +"AnalyticsDashboard/SpendVisuals/SpendLast24Months",
    GetSpendVisualsApplicationsLastMonths:BaseURL +"AnalyticsDashboard/SpendVisuals/ApplicationsLastMonths",
    GetSpendVisualsJobsPostedPerMonth:BaseURL +"AnalyticsDashboard/SpendVisuals/JobsLastMonths",
    GetSpendVisualsBudgetVsSpendThisMonth:BaseURL +"AnalyticsDashboard/SpendVisuals/BudgetVsSpendThisMonth",
    GetSpendVisualsBudgetSpendThisMonthBySupplier:BaseURL +"AnalyticsDashboard/SpendVisuals/BudgetSpendThisMonthBySupplier",
    //Spend Data
    GetSpendDataLiveJobsLowAppVolume:BaseURL +"AnalyticsDashboard/SpendData/LiveJobsLowAppVolume",
    GetSpendDataExpiredJobsLowAppVolume:BaseURL +"AnalyticsDashboard/SpendData/ExpiredJobsLowAppVolume",
    GetSpendDataLiveJobTitlesLowAppVolume:BaseURL +"AnalyticsDashboard/SpendData/LiveJobTitlesLowAppVolume",
    GetSpendDataLiveLocationsLowAppVolume:BaseURL +"AnalyticsDashboard/SpendData/LiveLocationsLowAppVolume",
    GetSpendDataExpiredJobTitlesLowAppVolume:BaseURL +"AnalyticsDashboard/SpendData/ExpiredJobTitlesLowAppVolume",
    GetSpendDataExpiredLocationsLowAppVolume:BaseURL +"AnalyticsDashboard/SpendData/ExpiredLocationsLowAppVolume",
    GetSpendDataLiveJobsHighSpend:BaseURL +"AnalyticsDashboard/SpendData/LiveJobsHighSpend",
    GetSpendDataExpiredJobsHighSpend:BaseURL +"AnalyticsDashboard/SpendData/ExpiredJobsHighSpend",
    GetSpendDataLiveJobTitlesHighSpend:BaseURL +"AnalyticsDashboard/SpendData/LiveJobTitlesHighSpend",
    GetSpendDataLiveLocationsHighSpend:BaseURL +"AnalyticsDashboard/SpendData/LiveLocationsHighSpend",
    GetSpendDataExpiredJobTitlesHighSpend:BaseURL +"AnalyticsDashboard/SpendData/ExpiredJobTitlesHighSpend",
    GetSpendDataExpiredLocationsHighSpend:BaseURL +"AnalyticsDashboard/SpendData/ExpiredLocationsHighSpend",
    //Cost
    GetCostCPAbyJobTitle:BaseURL +"AnalyticsDashboardCostPerApp/Cost/CPAbyJobTitle",
    GetCostCPAbyOccupation:BaseURL +"AnalyticsDashboardCostPerApp/Cost/CPAbyOccupation",
    //Suppliers
    GetSupplierSupplierByOccupation:BaseURL +"AnalyticsDashboardSupplier/Supplier/SupplierByOccupation",
    GetSupplierDashAppsPaidByOccupationSupplierDates:BaseURL +"AnalyticsDashboardSupplier/Supplier/PaidByOccupationSupplierDates",
    GetSupplierDashAppsPaidByJobTitleSupplierDates:BaseURL +"AnalyticsDashboardSupplier/Supplier/PaidByJobTitleSupplierDates",
    GetSupplierDashAppsByJobTitleSupplierDates:BaseURL +"AnalyticsDashboardSupplier/Supplier/ByJobTitleSupplierDates",
    //Market
    GetMarketData:BaseURL +"AnalyticsDashboard/MarketData",
    GetMarketDataOccupationInterview:BaseURL +"AnalyticsDashboard/MarketDataOccupationInterview",
  
    //SaasPartner
    ValidatePartnerToken: BaseURL + "Login/ValidatePartnerToken",
    // ==========================================================================================
    //==================================MULTI DASHBOARD==========================================
    //Spend Visuals
    GetMultiSpendVisualsApplications: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/Applications",
    GetMultiSpendVisualsApplicationsByCostCenter: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/ApplicationsByCostCenter",
    GetMultiSpendVisualsApplicationsBySupplier: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/ApplicationsBySupplier",
    GetMultiSpendVisualsAppsThisMonth: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/AppsThisMonth",
    GetMultiSpendVisualsApplicationsThisMonthBySupplier: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/ApplicationsThisMonthBySupplier",
    GetMultiSpendVisualsSpendThisMonth: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/SpendThisMonth",
    GetMultiSpendVisualsBudgetVsSpendThisMonth: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/BudgetVsSpendThisMonth",
    GetMultiSpendVisualsBudgetSpendThisMonthBySupplier: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/BudgetSpendThisMonthBySupplier",
    GetMultiSpendVisualsApplicationsLastMonths: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/ApplicationsLastMonths",
    GetMultiSpendVisualsSpendLast24Months: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/SpendLast24Months",
    GetMultiSpendVisualsCPAbyOccupation: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/CPAbyOccupation",
    GetMultiSpendVisualsJobPostingsByCostCenter: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/JobPostingsByCostCenter",
    GetMultiSpendVisualsApplicationsByOccupation: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/ApplicationsByOccupation",
    GetMultiSpendVisualsTotalSpendByCostCenter: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/TotalSpendByCostCenter",
    GetMultiSpendVisualsExpiredJobsLastDaysPerCostCenter: BaseURL + "AnalyticsDashboardMultiJobs/SpendVisuals/ExpiredJobsLastDaysPerCostCenter",
    //Spend Data
    GetMultiSpendDataLowJobsLive : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/LowJobsLive",
    GetMultiSpendDataLowJobsExpired : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/LowJobsExpired",
    GetMultiSpendDataLowJobsLiveTitles : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/LowJobsLiveTitles",
    GetMultiSpendDataLowJobsLiveLocations : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/LowJobsLiveLocations",
    GetMultiSpendDataLowJobsExpiredTitles : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/LowJobsExpiredTitles",
    GetMultiSpendDataLowJobsExpiredLocations : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/LowJobsExpiredLocations",
    GetMultiSpendDataHighJobsLive : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/HighJobsLive",
    GetMultiSpendDataHighJobsExpired : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/HighJobsExpired",
    GetMultiSpendDataHighJobsLiveTitles : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/HighJobsLiveTitles",
    GetMultiSpendDataHighJobsLiveLocations : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/HighJobsLiveLocations",
    GetMultiSpendDataHighJobsExpiredTitles : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/HighJobsExpiredTitles",
    GetMultiSpendDataHighJobsExpiredLocations : BaseURL + "AnalyticsDashboardMultiJobs/SpendData/HighJobsExpiredLocations",
    //Cost
    GetMultiCostCPAbyJobTitle: BaseURL + "AnalyticsDashboardCostPerApp/MultiCost/ByJobTitle",
    GetMultiCostCPAbyOccupation: BaseURL + "AnalyticsDashboardCostPerApp/MultiCost/CPAByOccupation",
    GetMultiCostbyOccupation: BaseURL + "AnalyticsDashboardCostPerApp/MultiCost/ByOccupation",
    //Suppliers
    GetMultiSupplierByOccupationPaid: BaseURL + "AnalyticsDashboardSupplier/MultiSupplier/Occupation/Paid",
    GetMultiSupplierByOccupation: BaseURL + "AnalyticsDashboardSupplier/MultiSupplier/Occupation",
    GetMultiSupplierByJobTitle: BaseURL + "AnalyticsDashboardSupplier/MultiSupplier/JobTitle",
    //WELCOME
    GetMoreInfo: BaseURL + "DefaultPage/MoreInfo",
    //LANDING PAGE
    GetCarrierData: LandingPageAPI + "reports/summary",
    GetLandingPage: LandingPageAPI + "reports/landing",
};
export default WebLinks;
